let cachedEl = null;
export function stripHtml(html) {
    if (!cachedEl) cachedEl = document.createElement('div');

    cachedEl.innerHTML = html;

    return cachedEl.textContent;
}